var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card", attrs: { "data-table-paginator": "" } },
    [
      _vm.title
        ? _c(
            "h5",
            { staticClass: "card-header" },
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _c("span", { staticClass: "badge badge-secondary" }, [
                _vm._v(_vm._s(_vm.items.length))
              ]),
              _vm._t("header-link")
            ],
            2
          )
        : _vm._e(),
      _vm.sortOptions.length > 0
        ? _c("div", { staticClass: "card-body text-center" }, [
            _c(
              "div",
              { staticClass: "form-check form-check-inline" },
              _vm._l(_vm.sortOptions, function(sortOption, index) {
                return _c(
                  "label",
                  { key: index, staticClass: "form-check-label mr-4" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.currentSortOption,
                          expression: "currentSortOption"
                        }
                      ],
                      staticClass: "form-check-input m-0",
                      attrs: { name: "sort-selector", type: "radio" },
                      domProps: {
                        value: sortOption.value,
                        checked: _vm._q(_vm.currentSortOption, sortOption.value)
                      },
                      on: {
                        change: function($event) {
                          _vm.currentSortOption = sortOption.value
                        }
                      }
                    }),
                    _vm._v(" " + _vm._s(sortOption.title) + " ")
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e(),
      _vm.items.length > 0
        ? _c(
            "table",
            {
              staticClass:
                "table table-striped mb-0 table-responsive col-12 table-typo p-0"
            },
            [
              _c("thead", { staticClass: "d-table col-12" }, [
                _c(
                  "tr",
                  [
                    _vm._l(_vm.columnNames, function(column) {
                      return [
                        _c("th", { class: column.style }, [
                          _vm._v(_vm._s(column.name))
                        ])
                      ]
                    })
                  ],
                  2
                )
              ]),
              _c(
                "tbody",
                { staticClass: "d-table col-12" },
                _vm._l(_vm.paginatedItems, function(group, index) {
                  return _c(
                    "tr",
                    { key: index },
                    [
                      _vm.showPageOffset
                        ? _c(
                            "th",
                            {
                              staticClass: "text-left align-middle",
                              attrs: { scope: "row" }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.currentPageNumber * _vm.rowsPerPage +
                                      (index + 1)
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._l(group, function(item, itemIndex) {
                        return _c(
                          "td",
                          { key: itemIndex, staticClass: "align-middle" },
                          [
                            _vm._t(
                              "item-data",
                              [
                                _c("a", { attrs: { href: item.getUrl() } }, [
                                  item.getLogo()
                                    ? _c("img", {
                                        attrs: {
                                          src: item.getLogo().url,
                                          title: item.getLogo().title
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" " + _vm._s(item.toString()) + " ")
                                ])
                              ],
                              { item: item }
                            )
                          ],
                          2
                        )
                      }),
                      !group[0].getBadge().isEmpty()
                        ? _c("td", { staticClass: "text-right align-middle" }, [
                            _c("strong", [
                              _vm._v(_vm._s(group[0].getBadge().get()))
                            ])
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm.items.length > 0
        ? _c("div", { staticClass: "card-footer text-center" }, [
            _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    type: "button",
                    "data-button-previous": "",
                    disabled:
                      _vm.totalPagesCount === 1 || _vm.currentPageNumber === 0
                  },
                  on: { click: _vm.previousPage }
                },
                [_vm._v(" " + _vm._s(_vm.T.wordsPrevious) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    type: "button",
                    "data-button-next": "",
                    disabled:
                      _vm.totalPagesCount === 1 ||
                      _vm.currentPageNumber >= _vm.totalPagesCount - 1
                  },
                  on: { click: _vm.nextPage }
                },
                [_vm._v(" " + _vm._s(_vm.T.wordsNext) + " ")]
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }